import Lottie from 'react-lottie-player'

type LottieWrapperProps = {
  animationData: object
  testId: string
  width?: number
  height?: number
  loop?: boolean
  className?: string
  style?: React.CSSProperties
  scale?: number
}

export function LottieWrapper({
  animationData,
  testId,
  width,
  height,
  loop = false,
  className,
  style,
  scale = 1,
}: LottieWrapperProps) {
  return (
    <Lottie
      play
      loop={loop}
      speed={0.7}
      animationData={animationData}
      data-testid={testId}
      className={className}
      style={{
        width,
        height,
        margin: '0px',
        gap: '0px',
        transform: `scale(${scale})`,
        transformOrigin: 'center',
        ...style,
      }}
    />
  )
}
